// extracted by mini-css-extract-plugin
export var actionButton = "_8b-1";
export var actionButtons = "_8b-2";
export var actions = "_8b-0";
export var aiUnread = "_8b-10";
export var alignCenter = "_8b-h";
export var backWrapper = "_8b-3";
export var cellContainer = "_8b-4";
export var checkboxContainer = "_8b-5";
export var contentContainer = "_8b-6";
export var contentHeader = "_8b-8";
export var conversationsTableWrapper = "_8b-s";
export var draftReplyBadgeContainer = "_8b-m";
export var dropdownItem = "_8b-b";
export var dropdownItemsContainer = "_8b-a";
export var dropdownTitle = "_8b-c";
export var errorIcon = "_8b-7";
export var filter = "_8b-d";
export var gray = "_8b-i";
export var headerActionButtons = "_8b-e";
export var headerCheckboxContainer = "_8b-f";
export var icon = "_8b-j";
export var menuContainer = "_8b-k";
export var noMoreTicketsIcon = "_8b-12";
export var noMoreTicketsSubText = "_8b-13";
export var oneLine = "_8b-l";
export var optionsButton = "_8b-n";
export var plus = "_8b-o";
export var portalButtonsWrapper = "_8b-g";
export var red = "_8b-p";
export var scrolledTop = "_8b-9";
export var search = "_8b-q";
export var selectedConversationsCount = "_8b-r";
export var spinner = "_8b-t";
export var strong = "_8b-u";
export var summaryCell = "_8b-v";
export var tableContainer = "_8b-11";
export var tagContainer = "_8b-w";
export var threeDots = "_8b-x";
export var twoLines = "_8b-y";
export var unread = "_8b-z";